<template>
  <div class="mission-result-container">
    <!-- 导航栏 -->
    <div class="custom-nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-left" @click="back()">
          <i class="nav-bar-arrow van-icon van-icon-arrow-left"></i>
        </div>
        <div class="nav-bar-title">
          {{$t('game.missionResult')}}
        </div>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <!-- 顶部信息卡片 -->
      <div class="info-card">
        <div class="top-section">
          <h1 class="mission-name">{{name}}</h1>
          <span class="mission-period">{{$t('game.day')}}{{expect}}{{$t('game.period')}}</span>
        </div>
      </div>

      <!-- 状态卡片 -->
      <div class="status-card">
        <div class="status-left">
          <h1 class="points-amount">{{money}}{{$t('points')}}</h1>
          <span class="points-label">{{$t('game.workPoints')}}</span>
        </div>
        <div class="status-divider"></div>
        <div class="status-right">
          <h1 class="status-text" :class="statusClass">
            {{statusText}}
          </h1>
        </div>
      </div>

      <!-- 订单信息卡片 -->
      <div class="order-card">
        <p class="order-item">
          <span class="order-label">{{$t('orderContentLabel')}}</span>
          <span class="order-value">{{touzhu}}</span>
        </p>
        <p class="order-item">
          <span class="order-label">{{$t('game.orderTime')}}</span>
          <span class="order-value">{{time}}</span>
        </p>
      </div>

      <!-- 详情卡片 -->
      <div class="detail-card">
        <div class="detail-title">
          {{$t('game.detail')}}
        </div>
        <div class="table-container">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{$t('game.content')}}</th>
                <th>{{$t('game.amount')}}</th>
                <th>{{$t('game.result')}}</th>
                <th>{{$t('game.time')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,key) in list" :key="key">
                <td>{{$t('game.'+v.type)}}</td>
                <td>{{v.money}}</td>
                <td :class="getResultClass(v.is_win)">{{getResultText(v.is_win)}}</td>
                <td>{{v.update_time}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[],
      name:'',
      expect:'',
      lid:'',
      money:'',
      touzhu:'',
      time:'',
      status:'',
    };
  },
  computed: {
    statusClass() {
      return this.status == 1 ? 'status-completed' : 'status-waiting';
    },
    statusText() {
      return this.status == 1 ? this.$t('game.giftCompleted') : this.$t('waitingResultLabel');
    }
  },
  methods: {
    back(){
      this.$router.push({path:'GameRecord'})
    },
    getVideoInfo(){
      this.$http({
        method: 'get',
        data:{lid:this.$route.query.lid,expect:this.$route.query.expect},
        url: 'user_get_game_detail'
      }).then(res=>{
        console.log(res.data)
        this.list = res.data;
      })
    },
    getResultClass(isWin) {
      switch(isWin) {
        case 1: return 'result-win';
        case 2: return 'result-failed';
        default: return 'result-waiting';
      }
    },
    getResultText(isWin) {
      switch(isWin) {
        case 1: return this.$t('game.win');
        case 2: return this.$t('game.missionFailed');
        default: return this.$t('waitingResultLabel');
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Home'})
    }else {
      this.name = this.$route.query.name;
      this.expect = this.$route.query.expect;
      this.money = this.$route.query.money;
      this.lid = this.$route.query.lid;
      this.touzhu = this.$route.query.touzhu;
      this.time = this.$route.query.time;
      this.status = this.$route.query.status;
      this.getVideoInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.mission-result-container {
  min-height: 100vh;
  background: #f5f5f5;
}

/* 导航栏样式 */
.custom-nav-bar {
  height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.nav-bar-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.nav-bar-left {
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.2);
  }
}

.nav-bar-arrow {
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
}

.nav-bar-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

/* 主要内容区域 */
.main-content {
  padding: 1rem;
}

/* 卡片通用样式 */
.info-card,
.status-card,
.order-card,
.detail-card {
  background: white;
  border-radius: 12px;
  border: 1.5px solid #e8e8e8;
  padding: 1.2rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

/* 顶部信息卡片 */
.info-card {
  .top-section {
    text-align: center;
    
    .mission-name {
      font-size: 1.2rem;
      font-weight: 600;
      color: #333;
      margin-bottom: 0.5rem;
    }
    
    .mission-period {
      font-size: 0.9rem;
      color: #969799;
    }
  }
}

/* 状态卡片 */
.status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  
  .status-left,
  .status-right {
    flex: 1;
    text-align: center;
  }
  
  .status-divider {
    width: 1px;
    height: 3rem;
    background: #f2f2f5;
  }
  
  .points-amount {
    font-size: 1.2rem;
    font-weight: 600;
    color: #667eea;
    margin-bottom: 0.5rem;
  }
  
  .points-label {
    font-size: 0.9rem;
    color: #969799;
  }
  
  .status-text {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    
    &.status-completed {
      color: #10b981;
    }
    
    &.status-waiting {
      color: #ef4444;
    }
  }
}

/* 订单信息卡片 */
.order-card {
  .order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.8rem 0;
    border-bottom: 1px solid #f2f2f5;
    
    &:last-child {
      border-bottom: none;
    }
    
    .order-label {
      font-size: 0.9rem;
      color: #666;
    }
    
    .order-value {
      font-size: 0.95rem;
      color: #333;
      font-weight: 500;
    }
  }
}

/* 详情卡片 */
.detail-card {
  .detail-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid #f2f2f5;
  }
}

.table-container {
  overflow-x: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  
  th, td {
    padding: 0.8rem 0.5rem;
    text-align: center;
    border: 1px solid #e8e8e8;
  }
  
  th {
    background: rgba(102, 126, 234, 0.05);
    color: #667eea;
    font-weight: 600;
    font-size: 0.8rem;
  }
  
  td {
    color: #333;
  }
  
  .result-win {
    color: #10b981;
    font-weight: 500;
  }
  
  .result-failed {
    color: #ef4444;
    font-weight: 500;
  }
  
  .result-waiting {
    color: #f59e0b;
    font-weight: 500;
  }
}

/* 响应式设计 */
@media (max-width: 320px) {
  .main-content {
    padding: 0.8rem;
  }
  
  .info-card,
  .status-card,
  .order-card,
  .detail-card {
    padding: 1rem;
    margin-bottom: 0.8rem;
  }
  
  .detail-table {
    font-size: 0.8rem;
    
    th, td {
      padding: 0.6rem 0.3rem;
    }
  }
}

@media (min-width: 768px) {
  .main-content {
    padding: 1.5rem;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .info-card,
  .status-card,
  .order-card,
  .detail-card {
    padding: 1.5rem;
    margin-bottom: 1.2rem;
  }
}
</style>